(function () {
  var settings = window.tanysiaDirectPopupSettings;
  if (!settings || !settings.enabled) return;

  var STORAGE_KEY = 'tanysia_direct_popup_dismissed_at';
  var TAB_POSITION_KEY = 'tanysia_direct_popup_tab_position';

  var overlay = document.getElementById('tanysia-direct-overlay');
  var tab = document.getElementById('tanysia-direct-tab');
  var copyBtn = document.getElementById('tanysia-direct-copy-btn');
  if (!overlay) return;

  function shouldShow() {
    var dismissedAt = localStorage.getItem(STORAGE_KEY);
    if (!dismissedAt) return true;
    var daysSince = (Date.now() - parseInt(dismissedAt, 10)) / (1000 * 60 * 60 * 24);
    return daysSince >= settings.reappearAfterDays;
  }

  function openPopup() {
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (tab) tab.classList.remove('is-visible');
  }

  function closePopup() {
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    if (tab) tab.classList.add('is-visible');
  }

  if (!shouldShow()) {
    if (tab) tab.classList.add('is-visible');
  } else {
    window.setTimeout(openPopup, settings.delaySeconds * 1000);
  }

  document.getElementById('tanysia-direct-close').addEventListener('click', closePopup);
  document.getElementById('tanysia-direct-decline').addEventListener('click', closePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) closePopup();
  });

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-code') || '';
      function showCopiedState() {
        copyBtn.classList.add('is-copied');
        window.setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 1500);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopiedState).catch(function () {
          fallbackCopy(code, showCopiedState);
        });
      } else {
        fallbackCopy(code, showCopiedState);
      }
    });
  }

  function fallbackCopy(text, onSuccess) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try { document.execCommand('copy'); onSuccess(); } catch (e) {}
    document.body.removeChild(textarea);
  }

  if (tab) {
    var isDragging = false, didDrag = false, dragStartY = 0, tabStartTop = 0, tabHeight = 0;

    function applyStoredPosition() {
      var stored = localStorage.getItem(TAB_POSITION_KEY);
      tabHeight = tab.offsetHeight || 120;
      if (stored) {
        var percent = parseFloat(stored);
        if (!isNaN(percent)) {
          setTabTop(percent * window.innerHeight);
          tab.classList.add('is-positioned');
        }
      }
    }

    function clampTop(top) {
      var margin = 20;
      var max = window.innerHeight - tabHeight - margin;
      if (top < margin) return margin;
      if (top > max) return max;
      return top;
    }

    function setTabTop(top) { tab.style.top = clampTop(top) + 'px'; }

    function getPointerY(e) {
      if (e.touches && e.touches.length) return e.touches[0].clientY;
      if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientY;
      return e.clientY;
    }

    function dragStart(e) {
      isDragging = true; didDrag = false;
      tabHeight = tab.offsetHeight || 120;
      dragStartY = getPointerY(e);
      tabStartTop = tab.getBoundingClientRect().top;
      tab.classList.add('is-dragging', 'is-positioned');
    }

    function dragMove(e) {
      if (!isDragging) return;
      var deltaY = getPointerY(e) - dragStartY;
      if (Math.abs(deltaY) > 4) didDrag = true;
      setTabTop(tabStartTop + deltaY);
    }

    function dragEnd() {
      if (!isDragging) return;
      isDragging = false;
      tab.classList.remove('is-dragging');
      var percent = tab.getBoundingClientRect().top / window.innerHeight;
      localStorage.setItem(TAB_POSITION_KEY, percent.toString());
      if (didDrag) {
        var swallowClick = function (e) {
          e.preventDefault(); e.stopPropagation();
          tab.removeEventListener('click', swallowClick, true);
        };
        tab.addEventListener('click', swallowClick, true);
      }
    }

    tab.addEventListener('mousedown', dragStart);
    document.addEventListener('mousemove', dragMove);
    document.addEventListener('mouseup', dragEnd);
    tab.addEventListener('touchstart', dragStart, { passive: true });
    document.addEventListener('touchmove', dragMove, { passive: true });
    document.addEventListener('touchend', dragEnd);
    tab.addEventListener('click', function (e) {
      if (didDrag) { e.preventDefault(); return; }
      openPopup();
    });

    applyStoredPosition();
    window.addEventListener('resize', function () {
      var stored = localStorage.getItem(TAB_POSITION_KEY);
      if (stored) {
        var percent = parseFloat(stored);
        if (!isNaN(percent)) setTabTop(percent * window.innerHeight);
      }
    });
  }
})();